/**
 * External dependencies
 */
import { createContext, useContext } from '@wordpress/element';

/**
 * Context consumed by inner blocks.
 */


export const CheckoutBlockContext =
	createContext ( {
		showCompanyField: false,
		requireCompanyField: false,
		showApartmentField: false,
		requireApartmentField: false,
		showPhoneField: false,
		requirePhoneField: false,
		showOrderNotes: true,
		showPolicyLinks: true,
		showReturnToCart: true,
		cartPageId: 0,
		showRateAfterTaxName: false,
		hasDarkControls: false,
		showFormStepNumbers: false,
	} );

export const CheckoutBlockControlsContext =
	createContext ( {
		addressFieldControls: () => null,
	} );

export const useCheckoutBlockContext = () => {
	return useContext( CheckoutBlockContext );
};

export const useCheckoutBlockControlsContext =
	() => {
		return useContext( CheckoutBlockControlsContext );
	};
